import { createSelector } from 'reselect';
import _ from 'lodash';

export const getMetadataState = state => _.get(state, 'metadata');
export const getAssetsState = state => _.get(state, 'assets');
export const getConfigState = state => _.get(state, 'config');

export const getMetadataModel = createSelector(
  [getMetadataState],
  ({ model }) => model,
);

export const getAssetsModel = createSelector(
  [getAssetsState],
  ({ model }) => model,
);

export const getConfigModel = createSelector(
  [getConfigState],
  ({ model }) => model,
);

export const getRegion = state => _.get(state, 'region');

export const getTranslationsState = createSelector(
  [getMetadataModel, getRegion],
  (metadata, region) => {
    return JSON.parse(metadata.translations).language[region]
  },
);

export const isLoading = state => {
  const metadataLoading = _.get(state, ['metadata', 'loading']);
  const assetsLoading = _.get(state, ['assets', 'loading']);
  const configLoading = _.get(state, ['config', 'loading']);
  return _.some([metadataLoading, assetsLoading, configLoading]);
};

export const isAllDataLoaded = createSelector(
  [getMetadataModel, getAssetsModel, getConfigModel],
  (metadata, assets, config) => !_.some([metadata, assets, config], _.isNil),
);

export const hasError = state => {
  const metadataModel = _.get(state, ['metadata', 'error']);
  const assetsModel = _.get(state, ['assets', 'error']);
  const configModel = _.get(state, ['config', 'error']);
  return _.some([metadataModel, assetsModel, configModel]);
};

export const getLoginOptions = createSelector(
  [getMetadataModel],
  metadata => JSON.parse(_.get(metadata, 'login_register_options_hbo', '{}')),
);

export const getLoginOptionsTabs = createSelector(
  [getLoginOptions, getRegion],
  (loginOptions, region) =>
    _.get(
      loginOptions,
      [region, 'login'],
      _.get(loginOptions, ['default', 'login'], []),
    ),
);

export const getTranslations = (state, region) => {
  return JSON.parse(state.metadata.translations).language[region];
};
